export enum SFA_FATAL_ERROR {
  BUSINESS_ID_MISSING = 'BUSINESS_ID_MISSING',
  BUSINESS_NOT_FOUND = 'BUSINESS_NOT_FOUND',
  CANCEL_BY_USER = 'CANCEL_BY_USER',
  ERROR_CREATING_LINK = 'ERROR_CREATING_LINK',
  NO_WORKSPACES = 'NO_WORKSPACES',
  USER_CANNOT_CREATE_NEW_ORG = 'USER_CANNOT_CREATE_NEW_ORG',
  USER_CANNOT_ACCESS_ALL_ORGS = 'USER_CANNOT_ACCESS_ALL_ORGS'
}

export enum SFA_LINK_OPTIONS {
  EXISTING = 'EXISTING',
  NEW = 'NEW'
}
